import { render, staticRenderFns } from "./stateBlurb.vue?vue&type=template&id=712e3280&"
import script from "./stateBlurb.vue?vue&type=script&lang=js&"
export * from "./stateBlurb.vue?vue&type=script&lang=js&"
import style0 from "./stateBlurb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports